export const eventsDetails = [
  {
    id: 1,
    title: 'event1Title',
    subtitle: 'subtitle',
    description: 'event1Details',
    paragraphs: ['event1Paragraph1', 'event1Paragraph2', 'event1Paragraph3', 'event1Details']
  },
  {
    id: 2,
    title: 'event2Title',
    subtitle: 'subtitle',
    description: 'event2Details',
    paragraphs: ['event2Paragraph1', 'event2Paragraph2', 'event2Paragraph3', 'event2Paragraph4']
  },
  {
    id: 3,
    title: 'event3Title',
    subtitle: 'subtitle',
    description: 'event3Details',
    paragraphs: ['event3Parahraph1', 'event3Parahraph2', 'event3Parahraph3', 'event3Parahraph4']
  },
  {
    id: 4,
    title: 'event4Title',
    subtitle: 'subtitle',
    description: 'event4Details',
    paragraphs: ['event4Parahraph1', 'event4Parahraph2', 'event4Parahraph3']
  },
  {
    id: 5,
    title: 'event5Title',
    subtitle: 'subtitle',
    description: 'event5Details',
    paragraphs: ['event5Parahraph1', 'event5Parahraph2', 'event5Parahraph3']
  },
];
